import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IFirmwareAssignmentContext,
	FirmwareAssignmentContext,
} from '../../../../../firmwareAssignmentState/firmwareAssignmentContext';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './ResetBtn.module.scss';

const ResetBtn: React.FC = () => {
	const { resetSelectedControls, IDSelectedTypeFirmware, isUnassignedFirmware, searchString } =
		useContext<IFirmwareAssignmentContext>(FirmwareAssignmentContext);

	return (
		<Button
			className={style.resetBtn}
			theme="secondary"
			onClick={resetSelectedControls}
			disabled={!IDSelectedTypeFirmware && !isUnassignedFirmware && !searchString}
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#resetIcon`} />
				</svg>
			}
			data-test="ResetBtn">
			<Text translationNameSpace="listing" translationKey="resetButton" asFragment={true} />
		</Button>
	);
};

export default ResetBtn;
